export const FIND_PRODUCT_ASSIGNMENTS = `
  query FindProductAssignments($productId: String!) {
    product {
      findProductAssignments(productId: $productId) {
        routines
        files
        addons
      }
    }
  }
`;
